import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDirection2"><Path d="M11.2495 3V8.25H4.38906L1.78906 11.5L4.38906 14.75H11.2495V19.5H6.99953V21H16.9995V19.5H12.7495V9.75H19.61L22.1927 6.52167L19.6314 3H11.2495Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirection2;
